import React, { useEffect, useMemo, useState } from 'react';
import DoughnutChart from '../../../../Charts/ChartJS/DoughnutChart';
import PieChart from '../../../../Charts/ChartJS/PieChart';
import RadialBarChart from '../../../../Charts/ApexchartsJS/RadialBarChart';
import BarChart from '../../../../Charts/ChartJS/BarChart';
import AreaChart from '../../../../Charts/ApexchartsJS/AreaChart';
import ColumnChart from '../../../../Charts/ApexchartsJS/ColumnChart';
import RadarChart from '../../../../Charts/ChartJS/RadarChart';
import LineChart from '../../../../Charts/ChartJS/LineChart';
import TableChart from '../../../../Charts/TableChart/TableChart';

// import { useDispatch } from "react-redux";
// import { ntxAPI } from '../../API/axiosNeatex';
// // import { useAppDispatch } from "../../store/hooks";
// import DoughnutChart from './ChartJS/DoughnutChart';
// // import { Card } from "../../components/card/card";
// import RadialBarChart from './ApexchartsJS/RadialBarChart';
// import PieChart from './ChartJS/PieChart';
// // import PieChartApex from "./ApexchartsJS/PieChart";
// import BarChart from './ChartJS/BarChart';
// import AreaChart from './ApexchartsJS/AreaChart';
// import ColumnChart from './ApexchartsJS/ColumnChart';
// import RadarChart from './ChartJS/RadarChart';
// import RadarChartApex from './ApexchartsJS/RadarChart';
//  import TableChart from './ChartJS/TableChart';
// import LineChart from '../../../../Charts/ChartJS/LineChart';

interface Props {
  DataChartReport?: Record<string, any>;
}

const RenderChart: React.FC<{ data: any }> = ({ data }) => {
 
  switch (data?.chartType) {
    case 'donut':
      return <DoughnutChart data={data} />;
    case 'pie':
      return <PieChart data={data} />;
    case 'radialBar':
      return <RadialBarChart data={data} />;
    case 'bar':
      return <BarChart data={data} />;
    // return <TableChart data={data} />;
    case 'area':
      return <AreaChart data={data} />;
    case 'column':
      return <ColumnChart data={data} />;
    // return <TableChart data={data} />;
    case 'radar':
      return <RadarChart data={data} />;
    case 'line':
      return <LineChart data={data} />;
    case 'table':
      return <TableChart data={data} />; // مكون الجدول الجديد
    default:
      return null;
  }
};

const Charts: React.FC<Props> = ({ DataChartReport }) => {
     
  //   console.log(chartId);
  //   console.log(DataChartReport);

  //   const chart = useMemo(() => {
  //     return <RenderChart data={DataChartReport} />;
  //   }, [DataChartReport]);

  //   return <>{chart}</>;
  return (
    <>
      <RenderChart data={DataChartReport} />
    </>
  );
};

export default Charts;
